@if (!hidden) {
    @if (model.background) {
        <img class="banner-esports-background" fill="object-fit" priority [ngSrc]="model.background" />
    }
    @if (model.icon) {
        <img class="banner-esports-icon" width="32" height="32" [ngSrc]="model.icon" />
    }
    <div class="banner-esports-info">
        <div class="title">{{ model.title }}</div>
        <span (click)="onClose()">
            <vn-icon name="theme-ex" class="close" size="12"> </vn-icon>
        </span>
        <div class="text">{{ model.text }}</div>
    </div>
}
